<template>
    <div v-if="appParams && appParams.staticTranslations">
        <h2 class="text-center">
            {{ appParams.staticTranslations["downloads.catalogue"] }}
        </h2>
        <section
            id="itb-flipbook-wrapper"
            ref="flipbookWrapper"
            class="d-flex flex-column align-items-center mb-1"
        >
            <flipbook
                v-slot="flipbook"
                class="flipbook"
                ref="flipbookComponent"
                @flip-left-end="onFlipLeftEnd"
                @flip-right-end="onFlipRightEnd"
                :key="resetPage"
                :pages="pages"
                :clickToZoom="false"
                :singlePage="isSinglePage"
                :startPage="startPage"
            ></flipbook>
            <div
                class="d-block d-md-flex justify-content-center align-items-center flex-wrap itb-flipbook-paginator"
                id="itb-flipbook-title"
                v-if="showFlipbookPaginator"
            >
                <div class="itb-page-buttons">
                    <!-- left button -->
                    <button
                        @click="flipLeft"
                        class="itb-page-left"
                        :disabled="page == 1"
                    >
                        <img
                            v-if="page == 1"
                            src="/images/icons/4soft_icon_angle-left-gray.svg"
                            alt="prev"
                            class="itb-icon"
                        />
                        <img
                            src="/images/icons/4soft_icon_angle-left-blue.svg"
                            alt="prev"
                            class="itb-icon"
                            v-else
                        />
                    </button>

                    <span>
                        {{ appParams.staticTranslations["general.page"] }}
                        {{ page }} /
                        {{ numPages }}
                    </span>

                    <!-- right button -->
                    <button
                        @click="flipRight"
                        class="itb-page-right"
                        :disabled="page == numPages"
                    >
                        <img
                            v-if="page == numPages"
                            src="/images/icons/4soft_icon_angle-right-gray.svg"
                            alt="next"
                            class="itb-icon"
                        />
                        <img
                            src="/images/icons/4soft_icon_angle-right-blue.svg"
                            alt="next"
                            class="itb-icon"
                            v-else
                        />
                    </button>
                </div>
                <div
                    class="itb-go-page-wrapper ml-md-5 ml-0 d-flex justify-content-center align-items-center"
                >
                    <label>{{
                        appParams.staticTranslations["downloads.go_to_page"]
                    }}</label>
                    <input
                        class="ml-2"
                        v-model="pageToGo"
                        type="number"
                        min="1"
                        @input="correctInputPage"
                        v-on:keyup.enter="jumpToPage"
                        :max="numPages"
                    />
                    <button
                        class="btn btn-secondary btn-sm ml-2 itb-go-page-button"
                        style="box-shadow: none"
                        :class="{ 'itb-valid-page': pageToGo }"
                        :disabled="!pageToGo"
                        @click="jumpToPage"
                    >
                        {{ appParams.staticTranslations["downloads.send"] }}
                    </button>
                </div>
            </div>
        </section>
        <section
            class="itb-download-list"
            v-for="category in downloadCategories"
        >
            <h2 class="text-center">
                {{ appParams.staticTranslations["constants." + category.name] }}
            </h2>
            <div class="container">
                <div class="row mx-auto itb-wrapper-row">
                    <div
                        class="col-12 col-md-4"
                        v-for="(download, index) in category['downloads']"
                    >
                        <div class="card w-100 h-100">
                            <div
                                class="card-body d-flex align-items-center p-0"
                                v-lazy-container="{ selector: '.itb-lazy' }"
                            >
                                <img
                                    v-if="download.thumbnail"
                                    :data-src="
                                        '/uploads/' +
                                        download.thumbnail.path +
                                        '/' +
                                        download.thumbnail.name
                                    "
                                    :alt="download.name"
                                    style="max-width: 136px"
                                    class="itb-lazy"
                                />
                                <div class="itb-content">
                                    <div>
                                        <span>{{ download.name }}</span>
                                    </div>
                                    <div>
                                        <div>
                                            <a
                                                :href="
                                                    '/uploads/' +
                                                    download.file.path +
                                                    '/' +
                                                    download.file.name
                                                "
                                                class="ml-auto"
                                                download
                                                v-if="download.file"
                                            >
                                                <span>{{
                                                    appParams
                                                        .staticTranslations[
                                                        "downloads.download"
                                                    ]
                                                }}</span>
                                                <img
                                                    src="/images/icons/4soft_icon_download_blue.svg"
                                                    :alt="
                                                        appParams
                                                            .staticTranslations[
                                                            'general.button'
                                                        ] +
                                                        ' ' +
                                                        appParams
                                                            .staticTranslations[
                                                            'downloads.download'
                                                        ]
                                                    "
                                                    class="itb-icon itb-download-icon"
                                                />
                                            </a>
                                        </div>
                                        <div>
                                            <button
                                                v-if="
                                                    download.file &&
                                                    download.file
                                                        .file_extension == 'pdf'
                                                "
                                                type="button"
                                                @click="browseFile(download.id)"
                                                class="btn btn-link p-0 itb-browse-file"
                                                hidden
                                            >
                                                {{
                                                    appParams
                                                        .staticTranslations[
                                                        "general.browse"
                                                    ]
                                                }}&nbsp;&ensp;<span
                                                    class="mdi mdi-eye"
                                                ></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Flipbook from "flipbook-vue";

export default {
    data() {
        return {
            pageParams: [],
            downloadCategories: [],
            pages: [],
            showFlipbook: false,
            resetPage: 0,
            showFlipbookPaginator: false,
            page: null,
            numPages: null,
            isSinglePage: false,
            pageToGo: null,
            startPage: null,
        };
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    mounted() {
        this.getDownloadPage();
        this.$eventBus.$on("refreshByLogin", (data) => {
            this.getDownloadPage();
        });
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
        }),
    },

    methods: {
        ...mapActions(["setPageParams"]),

        getDownloadPage() {
            axios
                .post("/getDownloadPage", { client_id: this.profile.id })
                .then((response) => {
                    this.browseFile();
                    this.pageParams = response.data.params;
                    this.downloadCategories = response.data.downloadCategories;
                    this.setPageParams(this.pageParams);

                    this.showFlipbookPaginator = true;
                    this.page = this.$refs.flipbookComponent.page;
                    if (this.$route.hash == "#itb-flipbook-title") {
                        this.goToCatalog();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        browseFile() {
            this.showFlipbook = true;
            this.pages = [];
            axios
                .post("/getFlipBookFiles", {
                    download_id: "katalog2022",
                })
                .then((response) => {
                    ++this.resetPage;
                    this.pages = response.data;
                    this.numPages = this.pages.length;
                    this.pages.unshift(null);
                })
                .catch((error) => {
                    console.log(error);
                    this.showFlipbook = false;
                });
        },
        closeFlipbook() {
            this.showFlipbook = false;

            this.pages = [];
        },

        goToCatalog() {
            this.$refs.flipbookWrapper.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        },
        flipLeft() {
            this.$refs.flipbookComponent.flipLeft();
            this.page = this.$refs.flipbookComponent.page;
        },
        flipRight() {
            this.$refs.flipbookComponent.flipRight();
            this.page = this.$refs.flipbookComponent.page;
        },
        onFlipLeftEnd() {
            this.page = this.$refs.flipbookComponent.page;
        },
        onFlipRightEnd() {
            this.page = this.$refs.flipbookComponent.page;
        },
        onResize() {
            if (window.innerWidth < 768) {
                this.isSinglePage = true;
            } else {
                this.isSinglePage = false;
            }
        },
        jumpToPage() {
            if (this.pageToGo) {
                this.startPage = parseInt(this.pageToGo);
                ++this.resetPage;
                this.page = this.startPage;
            }
        },
        correctInputPage() {
            let page = parseInt(this.pageToGo);
            if (Number.isNaN(page) || page > this.numPages || page < 1) {
                this.pageToGo = null;
            } else {
                this.pageToGo = page;
            }
        },
    },
    components: { Flipbook },
};
</script>
